<template>
    <div class="mt-6 content">
        <h3 class="has-text-white"><i class="fad fa-fw fa-circle-info mr-3"></i>Conference Information</h3>

        <p class="mt-6 has-text-white" v-if="!registration.id"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading conference...</p>

        <div v-else class="mt-6 pb-6">
            <b-message type="is-warning" class="mb-6" v-if="registration.is_po_pending">
                <strong>Please Note: </strong>
                You opted to use a Purchase Order (P.O.) for your registration. Your registration will not be complete until the purchase order process is complete.  Sessions and other content might not be available until the process is complete. Please contact the event organizer if you have any questions.
                <div class="mt-5 mb-4">
                    <router-link :to="{name: 'po-request'}">
                        <b-button type="is-warning" style="color:white;"><i class="fad fa-file-invoice mr-3"></i>Manage Purchase Order (P.O.)</b-button>
                    </router-link>
                </div>
            </b-message>
            <ui-card class="pt-4 pl-4 pr-6">
                <div class="columns is-gapless mb-6 pt-5" v-if="!registration.conference.information">
                    <div class="column is-narrow"><i class="far fa-fw fa-info-circle mr-2"></i></div>
                    <div class="column">
                        <div class="has-text-weight-bold">No additional information has been provided.</div>
                    </div>
                </div>
                <div v-else v-html="registration.conference.information" class="mb-6 pt-5"></div>
            </ui-card>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../../http_client";
    import moment from "moment";
    import UiCard from "../../components/UiCard";
    import {mapGetters} from "vuex";

    export default {
        components: {UiCard},
        props: ['registrationId'],
        data: function() {
            return {
                // registration: {
                //     conference: {}
                // }
            };
        },
        computed: {
            ...mapGetters(['registration']),
        },
        methods: {
            loadRegistration: function(force) {
                // http.get('app/registrations/' + this.registrationId, {force}).then(response => {
                //     this.registration = response.data;
                // });
                // console.log('loadRegistration', this.registration);
            }
        },
        mounted() {
            this.loadRegistration();
        }
    };
</script>

<style scoped>

</style>
